<template>
	<h2 class="heading2">{{title}}</h2>
	<div class="more">
		<a v-bind:href="archivelink" target="_blank"><i class="glyphicon glyphicon-arrow-right"></i> 一覧を見る</a>
	</div>
	<ul class="linkList">
		<li v-for="post in features">
			<a href="{{post.permalink}}" target="_blank">
				<div class="flexColumn">
					<div v-if="showthumb" class="flexColumn__col1">
						<img v-bind:src="post.thumbnail" class="img-responsive" alt="">
					</div>
					<div class="flexColumn__col2">
						<h3 class="heading3" v-html="post.title"></h3>
						<!-- <p class="pr"></p> -->
					</div>
				</div>
			</a>
		</li>
	</ul>

	<!-- <div v-on:click="debug">debug</div> -->
</template>

<script>
module.exports = {
	props: {
		categoryname: {
			type: String,
			required: true
		},
		perpage: {
			type: Number,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		archivelink: {
			type: String,
			required: true
		},
		showthumb: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	data: function () {
		return {
			features: [],
			wWidth: '',
			reload: {
				times: 3,
				delay: 5000
			}
		};
	},
	ready: function(){
		// GET request
		var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
		var hostname = document.location.hostname;
		var url = this.$route.devmode ? 'https://studio.powerpage.jp' : host + '//' + hostname;
		url = url + '/contents/wp-json/wp/v2/posts?_embed&filter[category_name]=' + this.categoryname + '&per_page=' + this.perpage;
		// console.log(url);

		this.getJson(url);
		// var dataArray = [];
		//
		// this.$http.get(url).then(
		// function (response) {
		// 	// success callback
		// 	// console.log(response.data);
		// 	var json = response.data;
		//
		// 	for (var i = 0; i < json.length; i++){
		// 		dataArray[i] = {};
		// 		dataArray[i].title = json[i].title.rendered;
		// 		dataArray[i].permalink = json[i].guid.rendered;
		// 		dataArray[i].thumbnail = ('wp:featuredmedia' in json[i]._embedded) ? json[i]._embedded['wp:featuredmedia']['0'].media_details.sizes.thumbnail.source_url : '/static/images/thumb/no_image.jpg';
		// 	}
		// 	this.$set('features', dataArray);
		// }, function (response) {
		// 	// error callback
		// 	console.log(response.statusText);
		// 	console.log('データの取得に失敗しました');
		// });
		// console.log(this.features);

		// resize
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('load', this.handleResize);
	},
	methods: {
		debug: function(){
			console.log(this.$data.features);
		},
		handleResize: function(){
			this.wWidth = window.innerWidth;
		},
		getJson: function(url, times = this.reload.times, delay = this.reload.delay){
			var dataArray = [];
			this.$http.get(url).then(
			function (response) {
				// success callback
				// console.log(response.data);
				var json = response.data;

				for (var i = 0; i < json.length; i++){
					dataArray[i] = {};
					dataArray[i].title = json[i].title.rendered;
					dataArray[i].permalink = json[i].guid.rendered;
					dataArray[i].thumbnail = '/static/images/thumb/no_image.jpg';
					if ('wp:featuredmedia' in json[i]._embedded) {
						if ('id' in json[i]._embedded['wp:featuredmedia']['0']) {
							dataArray[i].thumbnail = json[i]._embedded['wp:featuredmedia']['0'].media_details.sizes.thumbnail.source_url;
						}
					}
					// dataArray[i].thumbnail = ('wp:featuredmedia' in json[i]._embedded) ? json[i]._embedded['wp:featuredmedia']['0'].media_details.sizes.thumbnail.source_url : '/static/images/thumb/no_image.jpg';
				}
				this.$set('features', dataArray);
			}, function (response) {
				// error callback
				// console.log(response.statusText);
				console.log('データの取得に失敗しました');
				if (times > 0){
					setTimeout(this.getJson, delay, url, times - 1, delay);
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
// .flexColumn{
// 	.flexColumn__col1{
// 		width: 80px;
// 	}
// }
</style>



// WEBPACK FOOTER //
// posts.vue?5bd42dd9